// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3H0_x","bigColWidth":"Table_bigColWidth__1JYC_","biggerColWidth":"Table_biggerColWidth__2cRgC","row":"Table_row__1TtL4","col":"Table_col__3z_4Q"};